import { useTheme } from '@mui/material';
import {
    DateAndTimeSelectedEvent,
    EventScheduledEvent,
    EventTypeViewedEvent,
    PopupModal,
    ProfilePageViewedEvent,
    useCalendlyEventListener,
} from 'react-calendly';
import type { Prefill, Utm } from 'react-calendly/typings/calendly';

interface CalendlyDialogProps {
    onClose: () => void;
    open: boolean;
    url: string;
    memberUuid?: string;
    prefill?: {
        name: string;
        email: string;
        company?: string;
        comments?: string;
        customAnswers?: Prefill['customAnswers'];
    };
    pageSettings?: {
        hideEventTypeDetails?: boolean;
        queryString?: {
            utm_source?: string;
        };
    };
    utm?: Utm;
    onProfilePageViewed?: (e: ProfilePageViewedEvent) => void;
    onDateAndTimeSelected?: (e: DateAndTimeSelectedEvent) => void;
    onEventTypeViewed?: (e: EventTypeViewedEvent) => void;
    onEventScheduled?: (e: EventScheduledEvent) => void;
}

function CalendlyDialog({
    onClose,
    open,
    url,
    memberUuid,
    prefill,
    pageSettings = {},
    onProfilePageViewed,
    onDateAndTimeSelected,
    onEventTypeViewed,
    onEventScheduled,
    utm,
    ...props
}: CalendlyDialogProps) {
    const { palette } = useTheme();

    useCalendlyEventListener({
        onProfilePageViewed,
        onDateAndTimeSelected,
        onEventTypeViewed,
        onEventScheduled,
    });

    return (
        <PopupModal
            url={url}
            open={open}
            onModalClose={onClose}
            utm={{
                ...utm,
                ...(memberUuid ? { utmContent: `member:${memberUuid}` } : {}),
            }}
            pageSettings={{
                hideEventTypeDetails: true,
                ...pageSettings,
                backgroundColor: palette.background.default.replace('#', ''),
                textColor: palette.text.primary.replace('#', ''),
                primaryColor: palette.primary.main.replace('#', ''),
            }}
            prefill={{
                ...prefill,
                customAnswers: {
                    a1: prefill?.comments ?? prefill?.email,
                    a2: prefill?.company,
                    ...prefill?.customAnswers,
                },
            }}
            rootElement={document.getElementById('root') as HTMLElement}
            {...props}
        />
    );
}

export default CalendlyDialog;
